import useTranslation from 'next-translate/useTranslation'
import { twMerge } from 'tailwind-merge'

import { AddressSuggestion } from '@unreserved-frontend-v2/api/generated/graphql/types'
import Spinner from '@unreserved-frontend-v2/ui/spinner'

import { AddressResultRow } from '../address-result-row'

export interface AddressSearchContentProps {
  isMobile: boolean
  results: AddressSuggestion[] | undefined
  isSearchLoading: boolean
  isSearchError: boolean
  searchEnabled: boolean
  handleSelected: (address: AddressSuggestion) => void
  handleOptionEnterKey?: (event: React.KeyboardEvent<HTMLDivElement>, address: AddressSuggestion) => void
}

export const AddressSearchContent = ({
  isMobile,
  results,
  isSearchLoading,
  isSearchError,
  searchEnabled,
  handleSelected,
  handleOptionEnterKey,
}: AddressSearchContentProps) => {
  const { t } = useTranslation('geolocation')

  return (
    <>
      {/* Disabled as it is not within scope yet */}
      {/* { isMobile ? <MyLocationRow /> : null } */}

      {results?.map((address, index) => (
        <div
          key={index}
          data-testid={`address-search-result-${index}`}
          aria-selected={false}
          role="option"
          tabIndex={0}
          className={twMerge(
            isMobile
              ? 'border-b border-dashed border-shades-200 py-4 last:border-b-0'
              : 'cursor-pointer rounded py-1 px-4 outline-primary first:pt-2 last:pb-2 hover:bg-shades-50'
          )}
          onClick={() => handleSelected(address)}
          onKeyUp={(event) => (handleOptionEnterKey ? handleOptionEnterKey(event, address) : null)}
        >
          <AddressResultRow key={index} address={address} isMobile={isMobile} />
        </div>
      ))}

      {isSearchLoading ? (
        <div className={'flex h-[210px] items-center justify-center py-4'}>
          <Spinner size={27} className="text-primary" />
        </div>
      ) : null}

      {searchEnabled && results?.length === 0 && !isSearchLoading ? (
        <p className="text-shades-500 flex flex-col items-center justify-center py-4 pt-20 pb-20 leading-7">
          <span>{t('no-results')}</span>
          <span>{t('try-again')}</span>
        </p>
      ) : null}

      {isSearchError ? (
        <p className="text-shades-500 flex flex-col items-center justify-center py-4 pt-20 pb-20 leading-7">
          <span>{t('location-selector.lookup-failed')}</span>
        </p>
      ) : null}
    </>
  )
}
